<template>
    <div class="o-page__content u-pt-small">
        <div class="container-fluid">
            <div class="row">
                <div class="col-12 col-xl-12">
                    <h1 class="u-h3">Profile</h1>
                </div>
            </div>
            <div class="row u-mt-medium">
                <div class="col-6">
                    <div class="c-card u-p-medium" v-loading="loading.profile">
                        <form @submit.prevent="updateProfile">
                            <div class="row">
                                <div class="col-lg-12">
                                    <div class="c-field u-mb-small">
                                        <label class="c-field__label" for="email">Username</label>
                                        <input class="c-input" type="text" id="npp" disabled v-model="profile.username">
                                    </div>
                                    <div class="c-field u-mb-small">
                                        <label class="c-field__label" for="firstName">Role</label>
                                        <input class="c-input" type="text" disabled id="firstName" name="name" v-model="profile.role_name">
                                    </div>
                                    <div class="c-field u-mb-small" v-if="profile.role_id==2">
                                        <label class="c-field__label" for="firstName">Kode Wilayah</label>
                                        <input class="c-input" type="text" disabled id="firstName" name="name" v-model="profile.relation_code">
                                    </div>
                                    <div class="c-field u-mb-small" v-if="profile.role_id==3">
                                        <label class="c-field__label" for="firstName">Kode Outlet</label>
                                        <input class="c-input" type="text" disabled id="firstName" name="name" v-model="profile.relation_code">
                                    </div>
                                    <div class="c-field u-mb-small">
                                        <label class="c-field__label" for="firstName">Full Name</label>
                                        <input class="c-input" type="text" id="firstName" name="name" v-model="profile.name">
                                    </div>
                                    <div class="c-field u-mb-small">
                                        <label class="c-field__label" for="email">Email</label>
                                        <input class="c-input" type="email" id="email" name="name" v-model="profile.email">
                                    </div>
                                </div>
                            </div>
                            <div class="row u-mt-small">
                                <div class="col-lg-12 u-text-left">
                                    <button class="c-btn c-btn--success" type="submit" :disabled="(this.profile.name&&this.profile.email).length==0">Save</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
                <div class="col-6">
                    <div class="c-card u-p-medium" v-loading="loading.password">
                        <form @submit.prevent="changePhoto">
                            <div class="row">
                                <div class="col-lg-2">
                                    <div class="c-avatar c-avatar--small">
                                        <img class="c-avatar__img" :title="!preview?profile.name:'Click here to cancel change'" @click="cancel" :src="profile.photo!==''?(preview!==''?preview:profile.photo):'/assets/img/placeholder.jpg'">
                                    </div>
                                </div>
                                <div class="col-lg-6">
                                    <div class="c-field u-mb-small">
                                        <input class="c-input" type="file" @change="onPhotoChanged">
                                        <i style="font-size:0.8em" v-if="preview">Click photo to cancel change</i>
                                    </div>
                                </div>
                                <div class="col-lg-4">
                                    <button class="c-btn c-btn--success" type="submit" :title="!preview?'':'Click photo to cancel change'" :disabled="!preview">Update Photo</button>
                                </div>
                            </div>
                        </form>
                    </div>
                    <div class="c-card u-p-medium u-mt-small" v-loading="loading.password">
                        <form @submit.prevent="changePassword">
                            <div class="row">
                                <div class="col-lg-12">
                                    <div class="c-field u-mb-small">
                                        <label class="c-field__label" for="firstName">Old password</label>
                                        <input class="c-input" type="password" v-model="password.old">
                                    </div>
                                    <div class="c-field u-mb-small">
                                        <label class="c-field__label" for="email">New password</label>
                                        <input class="c-input" type="password" v-model="password.new">
                                    </div>
                                    <div class="c-field u-mb-small">
                                        <label class="c-field__label" for="email">Re-type new password</label>
                                        <input class="c-input" type="password" v-model="password.renew">
                                    </div>
                                </div>
                            </div>
                            <div class="row u-mt-small">
                                <div class="col-lg-12 u-text-left">
                                    <button class="c-btn c-btn--success" type="submit" :disabled="(this.password.old&&this.password.new&&this.password.renew).length==0">Update Password</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import { mapActions } from 'vuex';
    import api from '@/api/admin'
    export default {
        name: 'profile',
        data() {
            return {
                loading: {
                    profile: false,
                    password: false
                },
                profile: {
                    name: '',
                    username: '',
                    email: '',
                    photo: '',
                    role_id: '',
                    role_name: '',
                    relation_code: ''
                },
                password: {
                    old: '',
                    new: '',
                    renew: ''
                },
                preview: ''
            }
        },
        mounted () {
            this.fetch();
        },
        methods: {
            ...mapActions([
                'logout'
            ]),
            fetch() {
                var self = this
                api.get()
                .then(function (response) {
                    self.profile.name = response.data.data.name
                    self.profile.username = response.data.data.username
                    self.profile.email = response.data.data.email ? response.data.data.email : ''
                    self.profile.photo = response.data.data.photo
                    self.profile.relation_code = response.data.data.relation_code
                    self.profile.role_id = response.data.data.user_role_id
                    self.profile.role_name = response.data.data.user_role_id==1||4?'Admin':(response.data.data.user_role_id==2?'Admin Wilayah':'Admin Outlet')
                })
                .catch(function (error) {
                    console.log(error);
                    if(error.response.status == 403){
                        self.logout()
                    }
                })
            },
            updateProfile() {
                var self = this
                api.profile({name: this.profile.name,email: this.profile.email})
                .then(function (response) {
                    self.$message({
                        type: 'success',
                        message: response.data.message
                    });
                    localStorage.setItem('name', response.data.data.name)
                    localStorage.setItem('email', response.data.data.email)
                    // location.reload()
                })
                .catch(function (error) {
                    console.log(error);
                    if(error.response.status == 403){
                        self.logout()
                    }
                })
            },
            changePassword() {
                if(this.password.renew != this.password.new){
                    this.$message({
                        type: 'error',
                        message: 'Re-type new password is not equal with new password'
                    });
                } else {
                    var self = this
                    api.password({old_password: this.password.old, new_password: this.password.new})
                    .then(function (response) {
                        self.$message({
                            type: 'success',
                            message: response.data.message
                        });
                        self.password.old = ''
                        self.password.new = ''
                        self.password.renew = ''
                        self.fetch()
                    })
                    .catch(function (error) {
                        console.log(error);
                        self.$message({
                            type: 'error',
                            message: error.response.data.message
                        });
                        if(error.response.status == 403){
                            self.logout()
                        }
                    })
                }
            },
            onPhotoChanged (event) {
                const file = event.target.files[0]
                this.profile.photo = file
                this.preview = URL.createObjectURL(file)
            },
            changePhoto() {
                const formData = new FormData()
                formData.append('photo', this.profile.photo)
                var self = this
                api.photo(formData)
                .then(function (response) {
                    self.$message({
                        type: 'success',
                        message: response.data.message
                    });
                    self.profile.photo = ''
                    localStorage.setItem('photo', response.data.data.photo)
                    self.fetch()
                })
                .catch(function (error) {
                    console.log(error);
                    self.$message({
                        type: 'error',
                        message: error.response.data.message
                    });
                    if(error.response.status == 403){
                        self.logout()
                    }
                })
            },
            cancel(){
                this.profile.photo = localStorage.getItem('photo')
                this.preview = ''
            }
        },
    }
</script>

<style lang="scss" scoped>

</style>